import axios from 'axios'
import { enqueueSnackbar } from 'web/src/app/root/actions'

export async function getLocationDetails(id) {
    return axios
        .get(`${process.env.API_URL}/locations/${id}`)
        .then(response => response.data)
}

export async function craeteUser(data) {
    return axios
        .post(`${process.env.API_URL}/users`, data)
        .then(response => response.data)
}

export async function checkUserByEmail(email) {
    return axios
        .get(`${process.env.API_URL}/users/check?email=${email}`)
        .then(response => response.data)
}

export const newUserSetupEmailRequest = body => {
    return axios.post(`${process.env.API_URL}/users/new-user-setup-email`, body)
}

export const newUserSetupEmailRequestHandler = async ({
    userInvitationData,
    dispatch,
    successMsg,
    errorMsg
}) => {
    try {
        await newUserSetupEmailRequest(userInvitationData)
        dispatch(
            enqueueSnackbar({
                message: successMsg,
                options: {
                    variant: 'success'
                }
            })
        )
    } catch (error) {
        dispatch(
            enqueueSnackbar({
                message: errorMsg,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

export async function checkHasRoleUsers({ roleId }) {
    return axios
        .get(`${process.env.API_URL}/roles/${roleId}/check`)
        .then(response => response.data)
}

export async function reassignAndDeleteRole({ roleId, reassignRoleId }) {
    return axios
        .put(
            `${process.env.API_URL}/roles/${roleId}/reassign/${reassignRoleId}`
        )
        .then(response => response.data)
}
